export default {
  getStudyMaterial: "/studyMaterial/getStudyMaterial"
};
